const style = {}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/UserEditor/style/ColorBlind/user.js